import { TableCell } from '@material-ui/core';
import React, { Component } from 'react';
export class ReferenceCell extends Component {
  render() {
    const {
      content,
      fieldName,
      virtual
    } = this.props;
    return /*#__PURE__*/React.createElement(TableCell, {
      style: virtual ? {
        height: '57px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0
      } : {},
      component: virtual ? 'div' : 'td'
    }, /*#__PURE__*/React.createElement("span", null, content[fieldName]));
  }
}
//# sourceMappingURL=ReferenceCell.js.map